import axios from 'axios';

import { apiConfig } from '@constants';

import { getDspAuthHeader } from '../../helpers/DspAuth';
import { platformName } from '../../helpers/Platform';

const devicePlatform = platformName();

export const checkCableAuthorization = async (token, guid, deviceInfoString) => {
  try {
    return await axios.get(`${apiConfig.ADOBE_TVE_CHECKAUTHN_URL}&deviceId=${guid}&deviceType=${devicePlatform}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Device-Info': deviceInfoString,
      },
    });
  } catch (requestError) {
    return requestError.response?.data;
  }
};

export const checkPaidAuthorization = async (retry = false) => {
  try {
    const headers = await getDspAuthHeader(retry);

    if (!headers) {
      throw new Error('No DSP tokens');
    }
    return await axios.get(apiConfig.DSP_USER_PRODUCT_URL, { headers });
  } catch (error) {
    if (retry) {
      return { data: null, error };
    }
    return await checkPaidAuthorization(true);
  }
};
